// The largest member cap a Circle leader can set (`circles.max_members`).
// The Circle create/update schemas enforce it and the admin form validates
// against it before saving, so both say the same number. It also bounds a
// leader's target size (`circles_target_size_range`).
export const CIRCLE_MAX_MEMBERS_CAP = 10000;
// The smallest target size a leader can set: a Circle is at least two people.
export const CIRCLE_TARGET_SIZE_MIN = 2;
// How many discussion topics a Circle carries at most (the Circle
// create/update schemas and the leader forms).
export const CIRCLE_MAX_TOPICS = 5;
// The longest search (`q`, as sent: trimmed) the Circles directory runs. The
// API answers 422 past it; the web caps its search box here and reads an
// oversize URL value as absent. (The place-text cap is PLACE_TEXT_MAX in
// views/place.)
export const CIRCLE_SEARCH_MAX = 100;
//# sourceMappingURL=circle-limits.js.map